/**
 * 업데이트 소식 문구 — `landing` 네임스페이스의 `site.releases` 로 합쳐진다. 항목 키는 `RELEASE_ITEMS` 의 `key`.
 * 설명은 기능이 해내는 일만 짧게 — 쓰는 순서·버튼 이름은 넣지 않는다(releases 「소식 항목 구성」).
 */
const landingReleases = {
  "eyebrow": "업데이트 소식",
  "title": "더 새로워진 드론스퀘어",
  "lead": "가장 앞선 현장 기술을 드론스퀘어에서 먼저 만나 보세요.",
  "demo": "시연 영상 보기",
  "demoLabel": "시연 영상 보기 — {{topic}}",
  "demoStepLabel": "시연 영상 보기 — {{topic}}, {{step}}단계부터",
  "artLabel": "{{title}} 개념 그림",
  "items": {
    "auto_mapping": {
      "title": "GCP 자동 인식",
      "description": "표준 표식을 스스로 찾아내 기준점 작업 없이 지도를 완성합니다."
    },
    "equip_sim": {
      "title": "장비 동선 시뮬레이션",
      "description": "장비 여러 대를 실제 크기로 움직여 보며 충돌 위험을 미리 찾아냅니다."
    },
    "linear_ew": {
      "title": "선형 기반 토공",
      "description": "선형 하나로 측점마다 절토·성토량이 계산됩니다."
    },
    "ew_summary": {
      "title": "3D 토공량 계산",
      "description": "도면과 3D를 비교해 계획·기성·잔여 물량을 자동으로 계산합니다."
    },
    "folders": {
      "title": "모든 데이터 폴더 관리",
      "description": "자료가 아무리 많아도 폴더로 묶어 바로 찾습니다."
    },
    "walk_roadview": {
      "title": "360° 로드뷰",
      "description": "사무실에서도 360° 사진으로 현장을 걷듯 둘러봅니다."
    },
    "history": {
      "title": "프로젝트 히스토리",
      "description": "생성·수정·삭제 이력이 시간순으로 남아 변경 내역을 한눈에 봅니다."
    },
    "area_capture": {
      "title": "영역 캡쳐",
      "description": "필요한 영역만 잘라 고해상도 이미지로 바로 받습니다."
    },
    "issue_comments": {
      "title": "이슈 댓글",
      "description": "댓글과 사진으로 현장과 사무실이 같은 이슈를 함께 봅니다."
    },
    "pano360": {
      "title": "360° 사진·영상 뷰어",
      "description": "360° 사진과 영상으로 현장을 사방으로 둘러봅니다."
    },
    "clip_box": {
      "title": "3D 절단면 도구",
      "description": "3D 모델을 잘라 가려진 안쪽까지 측정하고 기록합니다."
    },
    "dsm_color": {
      "title": "3D 고도 색상",
      "description": "높이별 색으로 3D 지형의 높낮이가 한눈에 드러납니다."
    },
    "vectors": {
      "title": "좌표 입력 3D 벡터",
      "description": "설계 좌표를 따라 3D 선형이 현장 위에 그대로 그려집니다."
    },
    "workers": {
      "title": "작업자 위치 관제",
      "description": "작업자 위치를 실시간으로 보여 주고, 금지 구역에 들어가면 바로 알립니다."
    },
    "first_person": {
      "title": "1인칭 비행 시점",
      "description": "3D 현장 속을 직접 날아다니며 구석구석 살핍니다."
    },
    "geolog_map": {
      "title": "지오로그",
      "description": "사진과 영상이 찍힌 자리 그대로 지도 위에 놓입니다."
    },
    "ja": {
      "title": "일본어·크메르어 지원",
      "description": "4개 언어와 현지 시간대를 지원해 해외 현장도 같은 화면으로 관리합니다."
    },
    "dxf_on_3d": {
      "title": "3D 도면 오버레이",
      "description": "설계 도면을 3D 지형 위에 입혀 설계와 현장을 입체적으로 비교합니다."
    },
    "profile_3d": {
      "title": "3D 종·횡단면 그래프",
      "description": "선형을 따라 3D 모델의 종·횡단면을 바로 확인합니다."
    }
  }
} as const;

export default landingReleases;
